import { render, staticRenderFns } from "./OrderServices.vue?vue&type=template&id=1922b083"
import script from "./OrderServices.vue?vue&type=script&lang=js"
export * from "./OrderServices.vue?vue&type=script&lang=js"
import style0 from "./OrderServices.vue?vue&type=style&index=0&id=1922b083&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports